import { create } from 'zustand';

interface NavigationContextState {
  activeTab: string;
  selectedTenderId: number | null;
  selectedSupplierId: number | null;
  supplierTabIndex: number | null;
  analysisPageName: string | null;
  setActiveTab: (tab: string) => void;
  setSelectedTenderId: (tenderId: number | null) => void;
  setSelectedSupplierId: (supplierId: number | null) => void;
  setSupplierTabIndex: (index: number | null) => void;
  setAnalysisPageName: (name: string | null) => void;
  getAgentType: () => string;
  reset: () => void;
  initializeFromURL: (searchParams: URLSearchParams) => void;
  updateURL: (currentPath: string) => void;
}

export const useNavigationContextStore = create<NavigationContextState>((set, get) => ({
  activeTab: 'analysis',
  selectedTenderId: null,
  selectedSupplierId: null,
  supplierTabIndex: null,
  analysisPageName: null,
  
  setActiveTab: (tab) => set({ activeTab: tab }),
  setAnalysisPageName: (name) => set({ analysisPageName: name }),
  
  setSelectedTenderId: (tenderId) => set({ selectedTenderId: tenderId }),
  
  setSelectedSupplierId: (supplierId) => set({ selectedSupplierId: supplierId }),
  
  setSupplierTabIndex: (index) => set({ supplierTabIndex: index }),
  
  getAgentType: () => {
    const { activeTab } = get();
    switch (activeTab) {
      case 'targets':
        return 'negotiation_strategy_v3';
      case 'targets-new':
        return 'negotiation_strategy_v3';
      case 'briefing':
        return 'briefing_update';
      case 'scenario':
        return 'scenario_planning';
      case 'analysis':
      default:
        return 'general';
    }
  },
  
  initializeFromURL: (searchParams) => {
    const tab = searchParams.get('tab') || 'analysis';
    const tenderId = searchParams.get('tender');
    const supplierId = searchParams.get('supplier');
    const supplierTab = searchParams.get('supplierTab');
    
    set({
      activeTab: tab,
      selectedTenderId: tenderId ? parseInt(tenderId, 10) : null,
      selectedSupplierId: supplierId ? parseInt(supplierId, 10) : null,
      supplierTabIndex: supplierTab ? parseInt(supplierTab, 10) : null,
    });
  },
  
  updateURL: (currentPath) => {
    const { activeTab, selectedTenderId, selectedSupplierId, supplierTabIndex } = get();
    const url = new URL(window.location.origin + currentPath);
    
    // Update search parameters
    url.searchParams.set('tab', activeTab);
    if (selectedTenderId) url.searchParams.set('tender', selectedTenderId.toString());
    if (selectedSupplierId) url.searchParams.set('supplier', selectedSupplierId.toString());
    if (supplierTabIndex !== null) url.searchParams.set('supplierTab', supplierTabIndex.toString());
    
    // Use replaceState to avoid history pollution
    window.history.replaceState(null, '', url.pathname + url.search);
  },
  
  reset: () => set({ 
    activeTab: 'analysis', 
    selectedTenderId: null,
    selectedSupplierId: null,
    supplierTabIndex: null,
    analysisPageName: null
  })
}));
